import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IPrivateCompanyLink, privateCompanyLinkManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';

const PRIVATE_COMPANY_LINK_MODULE = 'privateCompanyLinks';

const dataObjectModule = getDataObjectsModule<IPrivateCompanyLink>(privateCompanyLinkManager, 1);
const searchModule = getSearchModule<IPrivateCompanyLink>(privateCompanyLinkManager);

const privateCompanyLinkModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(PRIVATE_COMPANY_LINK_MODULE, privateCompanyLinkModuleInstance);

export { PRIVATE_COMPANY_LINK_MODULE };
